export const isDelayNode = (audioNode) => {
    return 'delayTime' in audioNode;
};
//# sourceMappingURL=/build/es2018/guards/delay-node.js.map